import { abyssColors } from '@/theme/colors';
import {
  Box,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  Typography,
  styled as muiStyled,
} from '@mui/material';

type SliderProps = {
  open: boolean;
};

export const OverrideSection = muiStyled(Stack)(() => ({
  padding: '3.2rem 2rem 2.4rem 2.4rem',
  gap: '1.6rem',
  position: 'relative',
}));

export const LineBreak = muiStyled(Box)(() => ({
  height: '0.1rem',
  width: 'calc(100% - 1.6rem)',
  background: abyssColors.primary[300],
  opacity: 0.2,
  margin: '0 0.8rem',
}));

export const Title = muiStyled(Typography)(() => ({
  fontSize: '1.6rem',
  fontWeight: 500,
  color: abyssColors.primary[500],
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
}));

export const CustomSwitch = muiStyled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#2690ca',
    '&:hover': {
      backgroundColor: 'rgba(38, 144, 202, 0.08)',
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#82badb',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#999a9c',
  },
  '& .MuiSwitch-thumb': {
    boxShadow:
      '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.20)',
  },
}));

export const RadioLabel = muiStyled(Typography)(() => ({
  fontSize: '1.4rem',
  fontWeight: 400,
  color: abyssColors.primary[500],
  lineHeight: 'normal',
}));

export const CustomRadioGroup = muiStyled(RadioGroup)(() => ({
  display: 'flex',
  gap: '0.5rem',
}));

export const CustomRadio = muiStyled(Radio)(() => ({
  color: '#7e9bbb',
  '&.Mui-checked': {
    color: '#0c7cbb',
  },
}));

export const CustomSlider = muiStyled(Box)<SliderProps>(({ open }) => ({
  overflow: 'hidden',
  maxHeight: open ? '100vh' : '0px',
  opacity: open ? 1 : 0,
  transition: 'all 500ms ease',
}));
